import { CommaListRenderer } from 'components/FieldRenderers/Renderers/commaList'
import { YesNoRenderer } from 'components/FieldRenderers/Renderers/yesNo'
import { Field } from 'types'

import { createField } from './createField'
import { FieldCreatorOptions } from './localTypes'

function commaListField<RecordType>(
    id: string,
    fallbackLabel: string,
    options: FieldCreatorOptions<RecordType>
): Field<RecordType> {
    const field = createField({
        ...options,
        id,
        name: options.name ?? fallbackLabel,
        shortName: options.shortName ?? fallbackLabel,
        minWidth: options.minWidth ?? 80,
        width: options.width ?? 180,
        dataIndex: options.dataIndex ?? [id],
        renderOptions: options.renderOptions ?? {
            render: (props) => CommaListRenderer<any>(props),
        },
    })
    // BodyCell's extractChildrenToAppend prepends the first antd child when
    // children.length === 2. A string[] dataIndex value otherwise reaches antd
    // as two children — the first element ends up duplicated above the
    // rendered list. Suppressing antd's default cell content avoids it.
    return {
        ...field,
        antTableColumnOptions: {
            ...field.antTableColumnOptions,
            render: () => null,
        },
    }
}

export function eans<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    return commaListField('eans', 'EANs', options)
}

export function gtins<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    return commaListField('gtins', 'GTINs', options)
}

export function upcs<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    return commaListField('upcs', 'UPCs', options)
}

export function sustainability<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    return commaListField('sustainability', 'Sustainability', options)
}

export function fsaHsaEligible<RecordType>(
    options: FieldCreatorOptions<RecordType> = {}
): Field<RecordType> {
    const id = 'fsa_hsa_eligible'
    return createField({
        ...options,
        id,
        name: options.name ?? 'FSA/HSA Eligible',
        shortName: options.shortName ?? 'FSA/HSA Eligible',
        minWidth: options.minWidth ?? 80,
        width: options.width ?? 120,
        dataIndex: options.dataIndex ?? [id],
        renderOptions: options.renderOptions ?? {
            render: (props) => YesNoRenderer<any>(props),
        },
    })
}
